<template>
    <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="false"
    >
        <template #layoutContent>
            <div class="card">
                <div class="card card-custom" >
                    <div class="card-header flex-wrap border-0 pt-6 pb-0">
                    <div class="card-title">
                        <h3 class="card-label">{{ $t('categories.list') }}</h3>
                    </div>
                    <div class="card-toolbar">
                        <Button btn-class="btn-sm" v-if="$can(abilities.CREATE_CATEGORY)" type="new" btn-text="categories.create" @click="openCreateCategoryModal"/>
                    </div>
                    </div>

                    <div class="card-body" >
                    <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_categories" style="margin-top: 13px !important; cursor:pointer">
                        <thead>
                        <tr class="text-start fw-bold fs-7 text-uppercase gs-0" style="background-color: #F2F3F4;">
                        <th class="min-w-100px">{{ $t('categories.image')}}</th>
                        <th class="min-w-100px">{{ $t('categories.name')}}</th>
                        <th class="min-w-200px">{{ $t('categories.subcategories')}}</th>
                        <th class="min-w-100px">{{ $t('action') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        </tbody>
                    </table>
                    </div>
                </div>
                <CategoryFormModal id="category-form-create" @after-create="reloadData" :category="formCreateData" />
                <CategoryFormModal id="category-form-edit" @after-update="reloadData" :isEdit="true" :category="formEditData" />
            </div>
        </template>
    </SubLayout>
</template>

<script setup>
    import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
    import {nextTick, onMounted, ref, watch} from "vue";
    import i18n from '@/plugins/i18n';
    import Ls from "@/services/ls";
    import {BASE_URL} from "@/services/api";
    import CategoryFormModal from '@/components/Category/CategoryFormModal.vue'
    import {useStore} from "vuex";
    import {useHasAbility} from "@/composables/hasAbility";
    import { useLocales } from "@/composables/locales";
    import Button from "@/components/Button.vue"
    import {useSwal} from "@/composables/useSwal";
    import abilities from "@/composables/abilities";
    import {Theme} from "@/composables/theming";

    const title = ref("breadcrumbs.categories.title")
    const breadcrumbs = ref([
        {
            name: 'breadcrumbs.categories.list',
            route: 'categories'
        }
    ])
    const store = useStore()
    const { can } = useHasAbility()
    const {showSwal} = useSwal()

    const table = ref()
    const formCreateData = ref({
        id: null,
        name: '',
        categories: [],
        image: null,
        image_url: null
    })

    const formEditData = ref({
        id: null,
        name: '',
        categories: [],
        image: null,
        image_url: null
    })

    const {locale, datatableLocaleUrl} = useLocales()

    watch(() => locale.value, () => {
        nextTick(() => fetchDatas() )
    })

    function fetchDatas() {
        const AUTH_TOKEN = Ls.get('auth.token')
        const pageLimit = Ls.get('pageLength')

        table.value = $("#kt_datatable_categories").DataTable({
            destroy: true,
            responsive: !0,
            searchDelay: 500,
            processing: !0,
            serverSide: !0,
            pageLength: pageLimit ||  5,
            lengthMenu: [5, 10, 25, 50, 75, 100 ],
            order: [[ 1, 'asc']],
            ajax: {
            url: BASE_URL + "/get/categories/datatables",
            type: "GET",
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
                request.setRequestHeader("Company", Ls.get('current.company'));
            }
            },
            columns: [
            { data: "image_url" },{ data: "name" },{ data: "parents" },{ data: "Actions", responsivePriority: -1 }
            ],
            columnDefs: [

            {
                targets: -4,
                orderable:false,
                searchable:false,
                className: "dt-center clickable" ,
                render: function (t, a, e, l) {
                return '<img id="'+ e.id +'" src="'+ e.image_url +'"  style="width: 50px; height: 50px;" />';
                },
            },

            {
                targets: -3,
                className: "dt-center clickable" ,
                render: function (t, a, e, l) {
                return '<span data-id="'+ e.id +'">' + t + "</span>";
                },
            },

            {
                targets: -2,
                orderable:false,
                className: "dt-center clickable" ,
                render: function (t, a, e, l) {
                let result = ''
                for (let element in t) {
                    result += '<span class="badge badge-light-primary" style="font-size:13px; margin:3px; padding:3px"><span data-id="' + e.id + '" data-value_id="' + element + '" data-value="' + t[element] + '" style="margin-left: 5px" class="valueRow' + l.row + ' label label-success label-inline font-weight-bolder mr-2 edit_value_btn">' + t[element] + '</span></span>';
                };
                return result
                },
            },

            

            {
                width: "20%",
                targets: -1,
                "className": "dt-center",
                title: "Actions",
                orderable: !1,
                render: (t, a, e, l) => {
                let render=""
                
                if(can(abilities.UPDATE_CATEGORY)){
                    render+='<a href="javascript:;" data-parents="'+ e.parent_id +'" data-image="'+ e.image_url +'"   data-id="'+ e.id +'" data-name="'+ e.name +'" data-image="'+e.image_url +'"  class="btn btn-sm btn-clean btn-icon   edit_btn" title="'+ i18n.global.t('button.edit') +'"><i data-parents="'+ e.parent_id +'"  data-image="'+ e.image_url +'"  data-id="'+ e.id +'" data-name="'+ e.name +'" data-image="'+e.image_url +'"    class="fas fa-edit fs-2"  style="color: '+Theme.gray +'"></i></a>'
                }
                  if(can(abilities.DELETE_CATEGORY)){
                    render += '<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'" class="btn btn-sm btn-clean btn-icon delete_btn" title="'+ i18n.global.t('button.delete') +'"><i data-row="'+ l.row +'" data-id="'+ e.id +'" class="fas fa-trash fs-2" style="color: '+Theme.gray +'"></i></a>'
                }

                return render
                },
            },

            ],
            language: {
            url: datatableLocaleUrl.value,
            }
        });

        $(document).on("click", "#kt_datatable_categories .edit_btn", (e) => {
            formEditData.value.id = e.target.getAttribute('data-id')
            formEditData.value.name = e.target.getAttribute('data-name')
            formEditData.value.image_url = e.target.getAttribute('data-image') ?? null
            formEditData.value.image = e.target.getAttribute('data-image') ?? null
            formEditData.value.categories =  e.target.getAttribute('data-parents') ? e.target.getAttribute('data-parents').split(",") : null
            formEditData.value.row = e.target.getAttribute('data-row')
            $('#category-form-edit').modal('toggle')
        });

        $(document).on("click", "#kt_datatable_categories .delete_btn", (e) => {
            deleteCategory(e.target.getAttribute('data-id'))
        });
    }

    function openCreateCategoryModal() {
        $('#category-form-create').modal('toggle')
    }

  
    async function deleteCategory(id) {
        showSwal(
            i18n.global.t('swal.title'),
            i18n.global.t('swal.categories_deleted')
        ).then( async (result) => {
            if (result.value) {
                store.dispatch('categories/deleteCategory', id).then((res) => {
                    table.value.ajax.reload()
                    window.toastr['success'](i18n.global.t('notification.category_deleted'))
                }).catch(() => {

                })
            }
        })
    }

    function reloadData () {
        formEditData.value.id = null
        formEditData.value.name = ''
        formEditData.value.image = null
        formEditData.value.image_url = null
        formEditData.value.categories = []
        formCreateData.value.id = null
        formCreateData.value.name = ''
        formCreateData.value.image = null
        formCreateData.value.image_url = null
        formCreateData.value.categories = []
        fetchDatas()
    }

    onMounted(() => {
        fetchDatas()
    })
</script>

<style scope>
.badge-light-primary {
    color: var(--bs-primary);
    background-color: var(--bs-light-primary);
    padding: 5px 10px !important;
}


</style>